import { RENTAL_ZONE } from '../../utils/mytTime.js';

/** 393 (#1313): a customer's penalty, as `GET /penalties/mine` lists it. */
export type PenaltyState = 'unpaid' | 'under_review' | 'rejected' | 'paid';
export interface PenaltyItem {
  id: string;
  type: string;
  type_label: string;
  amount_minor: number;
  on: string;
  plate_number: string;
  booking_ref: string;
  state: PenaltyState;
}
export interface PenaltyList {
  items: PenaltyItem[];
  unpaid_count: number;
}
/** One penalty, as `GET /penalties/mine/:id` gives it. */
export interface PenaltyDetail extends PenaltyItem {
  reason: string;
  car_label: string;
  customer_paid_on: string | null;
  reject_reason: string | null;
  receipt: { url: string; mime: string; uploaded_at: string | null } | null;
  payment_qr_url: string | null;
  /** 406 (#1369): set while the banks' Friday downtime pauses payments (the QR is then withheld). */
  payments_paused_until?: string | null;
}

/** The platform's own sentence for the block (403 PENALTY_UNPAID), shown before the form too. */
export const PENALTY_UNPAID_SENTENCE =
  'You have an unpaid penalty. Pay it and wait for approval before booking.';

export const STATE_LABEL: Record<PenaltyState, string> = {
  unpaid: 'Unpaid',
  under_review: 'Receipt under review',
  rejected: 'Receipt rejected',
  paid: 'Paid',
};
export const STATE_VARIANT = {
  unpaid: 'danger',
  under_review: 'warning',
  rejected: 'danger',
  paid: 'success',
} as const;

export const rm = (minor: number) => `RM ${(minor / 100).toFixed(2)}`;

/** "12 Oct 2026" from a Malaysian day `2026-10-12`. */
export function dayWords(day: string): string {
  return new Date(`${day}T00:00:00+08:00`).toLocaleDateString('en-GB', {
    timeZone: RENTAL_ZONE,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/** True only for a real penalty list that says something is unpaid (older test stand-ins return other payloads). */
export function owesPenalty(data: unknown): boolean {
  const n = (data as { unpaid_count?: unknown } | null)?.unpaid_count;
  return typeof n === 'number' && n > 0;
}
